<template>
  <div>
    <MenuSection
      v-for="(commandSet, index) in commandSource"
      :key="index"
      :editor="editor"
      :commands="commandSet"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, provide, readonly, ref } from 'vue';
import { MenuItemFn } from './menu-item';
import MenuSection from './MenuSection.vue';
import { Editor } from '@tiptap/core';

const props = defineProps<{
  commandSets: MenuItemFn[];
  editor: Editor;
}>();

/**
 * When this value is set to anything other than null,
 * these command sets will populate the menu.
 */
const commandOverrides = ref<MenuItemFn[] | null>(null);

/**
 * Calling this changes the menu contents.
 * Useful for creating "sub-menus" within the same toolbar.
 * @param com The menu item function array.
 */
function overrideCommands(com: MenuItemFn[]) {
  commandOverrides.value = com;
}

/**
 * Revert the menu to its initial state, which
 * is using the props given to the MenuSection.
 */
function revertCommandOverrides() {
  commandOverrides.value = null;
}

const commandSource = computed(() => commandOverrides.value ?? props.commandSets);

provide('menuCommandOverride', {
  commandOverrides: readonly(commandOverrides),
  overrideCommands,
  revertCommandOverrides,
});
</script>
